import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchEntitlement, guestRoundsToday, FREE_DAILY_LIMIT } from "../lib/billing";
import { useAuth } from "./AuthContext";

const EntitlementContext = createContext(null);

export function EntitlementProvider({ children }) {
  const { status } = useAuth();
  const [entitlement, setEntitlement] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (status === "cloud") {
      setLoading(true);
      try {
        const data = await fetchEntitlement();
        setEntitlement(data);
      } catch {
        setEntitlement(null);
      } finally {
        setLoading(false);
      }
    } else if (status === "guest") {
      // Guests have no trial, no premium — fully free tier
      const rt = guestRoundsToday();
      setEntitlement({
        entitled: false,
        premium: false,
        trial_active: false,
        trial_days_left: 0,
        rounds_today: rt,
        free_daily_limit: FREE_DAILY_LIMIT,
        can_play_today: rt < FREE_DAILY_LIMIT,
        guest: true,
      });
    } else {
      setEntitlement(null);
    }
  }, [status]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <EntitlementContext.Provider value={{ entitlement, loading, refresh }}>
      {children}
    </EntitlementContext.Provider>
  );
}

export const useEntitlement = () => useContext(EntitlementContext);
